import React from 'react';
import Middleware from '../../middleware';
import ProjectScope from '../projectScope/projectScope';

import IntlTelInput from 'react-intl-tel-input';
import {PhoneNumberUtil} from 'google-libphonenumber';
import 'file-loader?name=libphonenumber.js!../../../node_modules/react-intl-tel-input/dist/libphonenumber.js';
import misc from './../../misc';

const steps = {
  VerifyPhoneNumber: 0,
  TermsAndConditions: 1,
  UpdatePhone: 2,
  Updated: 3,
  Verified: 4
};


const phoneUtil = PhoneNumberUtil.getInstance();

export default class TwoFactorAuthView extends React.Component {
  constructor(props) {
    super(props);

    let number = phoneUtil.parse(props.phoneNumber);
    let phoneNumberValue =  "+" + number.getCountryCode() + " " + number.getNationalNumber();

    this.state = {
      step: steps.VerifyPhoneNumber,
      phone: phoneNumberValue,
      newPhone: phoneNumberValue,
      countryCode: number.getCountryCode(),
      authCode: '',
      validating: false,
      valid: true,
      phoneValid: true
    }
    this.generateAuthtoken();
  }

  
  handleChangeNumber = (a, b, c, phoneNumber) => {
    phoneNumber = phoneNumber.replace(/[^0-9\+\-\(\)\s\.]/gi, "");
    let prefix = `+${this.state.countryCode}`;
    if(!_.startsWith(phoneNumber, prefix + ' ') || _.trim(phoneNumber).length == 0) {
      let hasPrefix = phoneNumber.substring(0, prefix.length) == prefix;
      if(hasPrefix) phoneNumber = _.trim(phoneNumber.substring(prefix.length));
      phoneNumber = `${prefix} ${phoneNumber}`;
    }
    this.setState({newPhone: phoneNumber});
  }

  handleChangeFlag = (currentNumber, selectedCountryData) => {
    var matches = currentNumber.match(/(\+\d{1,4}\s)/gi);
    if(matches && matches.length > 1) {
      currentNumber = currentNumber.replace(/\+\d{1,4}\s/gi, '');
      currentNumber = `${matches[1]}${currentNumber}`;
    } else {
      currentNumber = `+${selectedCountryData.dialCode} ${currentNumber}`;
    }
    this.setState({countryCode: selectedCountryData.dialCode, newPhone: currentNumber}); 
  }

  generateAuthtoken = () => {
    Middleware.generateAuthenticationToken()
      .then((t) => {
        var token = t.data ? t.data : t;
        this.setState({token}, this.handleResendSMS);
      });
  }
  getContent = () => {
    switch(this.state) {
      case steps.VerifyPhoneNumber:
        return this.getVerifyPhoneNumberContent();
      case steps.TermsAndConditions:
        return this.getTermsAndConditionsContent();
      case steps.UpdatePhone:
        return this.getUpdatePhoneNumberContent();
      case steps.Updated:
        return this.getUpdatedContent();
      case steps.Verified:
        return this.getVerifiedContent();
    }
  }
  setStep = (step) => {
    this.setState({step});
  }
  render() { 
    return (
      <div className="TwoFactorAuth-popup-overlay">
        {this.getDialog()}
      </div>
    );
  }

  getDialogContent = () => {
    let content = {
      title: "Invalid Step",
      content: null,
      footer: null
    };
    switch(this.state.step) {
      case steps.VerifyPhoneNumber:
        content = this.getVerifyPhoneNumberContent();
        break;
      case steps.TermsAndConditions:
        content = this.getTermsAndConditionsContent();
        break;
      case steps.UpdatePhone:
        content = this.getUpdatePhoneContent();
        break;
    }
    return content;
  }

  handleResendSMS = () => {
    Middleware.sendAuthenticationRequest(this.state.token, this.state.phone, 1);
  }

  handleResendVoice = () => {
    Middleware.sendAuthenticationRequest(this.state.token, this.state.phone, 2);
  }

  handleCheckVerificationCode = (e) => {
    var authCode = _.trim(e.target.value);
    this.setState({authCode});
    if(authCode.length == 6) {
      this.setState({validating: true}, () => {
        Middleware.validateAuthenticationRequest(this.state.token, authCode, this.state.phone)
          .then((success) => {
            if(success.data) {
              let userInfo = ProjectScope.userInfo();
              userInfo.phone = this.state.phone;
              ProjectScope.setUserInfo(userInfo);
              this.setStep(steps.Verified);
            } else
              this.setState({valid: false}); //, validating: false
          });
      });
    }
  }

  validatePhone = (e) => {
    if(misc.isPhoneNumber(this.state.newPhone)) {
      this.setState({phone: this.state.newPhone, phoneValid: true}, () => { 
        this.setStep(steps.Updated); this.generateAuthtoken(); window.setTimeout(() => this.setStep(steps.VerifyPhoneNumber), 3750);
      });
    } else {
      this.setState({phoneValid: false});
    }
  }

  getVerifyPhoneNumberContent = () => {
    return {
      title: "Verify Phone Number",
      content: [
          (<input type="text" value={this.state.authCode}
            className={"TwoFactorAuth-popup-overlay-content-input " + (this.state.valid == false ? ' TwoFactorAuth-popup-overlay-content-input-invalid' : '')} 
            placeholder="Verification Code" onChange={this.handleCheckVerificationCode} />),
          (!this.state.valid ? <div className="TwoFactorAuth-popup-overlay-content-invalid">Verification Code is Invalid, please try again.</div> : null),
          (this.state.validating ? <img src="/content/views/quickquote-v3/images/icons/loading-spinner-blue.svg" alt="Validating..." className="TwoFactorAuth-popup-overlay-content-loading" /> : null),
          (<div className="TwoFactorAuth-popup-overlay-content-text">
              A text message with a verification code was just sent to <span className="TwoFactorAuth-popup-overlay-content-phone">{this.state.phone}</span>.
              Please enter it or chose to receive a call with your verification code to unlock pricing.
          </div>),
          (<div className="TwoFactorAuth-popup-overlay-back-button" onClick={() => this.setStep(steps.UpdatePhone)}>
              Update Phone Number
          </div>),
          (<div className="TwoFactorAuth-popup-overlay-content-actions">
              <div className="TwoFactorAuth-popup-overlay-content-actions-button" onClick={() => this.handleResendSMS()}>
                  Resend Code
              </div>
              <div className="TwoFactorAuth-popup-overlay-content-actions-button" onClick={() => this.handleResendVoice()}>
                  Recieve Call Instead
              </div>
          </div>)
      ],
      footer: [
            (<div className="TwoFactorAuth-popup-overlay-footer-terms" onClick={() => this.setStep(steps.TermsAndConditions)}>Terms and Conditions</div>),
            (<div className="TwoFactorAuth-popup-overlay-footer-actions">
                <div className="TwoFactorAuth-popup-overlay-footer-actions-button" onClick={() => this.props.onClose(false)}>Cancel</div>
            </div>)
      ]
    }
  }

  getTermsAndConditionsContent = () => {
    return {
      title: "Terms and Conditions",
      content: [
        (<div className="TwoFactorAuth-popup-overlay-content-text">
            Your information will only be used for the purpose of completing your order.  By submitting your information, you authorize a designer or sales representative to contact you to help complete your project.  Standard phone carrier text messaging or phone charges will apply.
          </div>)
      ],
      footer: [
        (<div className="TwoFactorAuth-popup-overlay-footer-actions">
          <div className="TwoFactorAuth-popup-overlay-footer-actions-button-green" onClick={() => this.setStep(steps.VerifyPhoneNumber)}>Continue</div>
        </div>)
      ]
    };
  }

  getUpdatePhoneContent = () => {
    return {
      title: "Update Phone Number",
      content: [
        (<div className="TwoFactorAuth-popup-overlay-content-text-title">
            Enter your phone number below
        </div>),
        (<div className="TwoFactorAuth-popup-overlay-content-text">
            <IntlTelInput  css={['intl-tel-input', 'TwoFactorAuth-popup-overlay-content-input']}
              utilsScript={'/content/views/quickquote-v3/libphonenumber.js'} 
              value={this.state.newPhone}
              onSelectFlag={this.handleChangeFlag}
              placeholder="Phone Number" 
              onPhoneNumberChange={this.handleChangeNumber}
              defaultCountry={ 'auto' } maxLength={16} />
        </div>),
        (!this.state.phoneValid && <div className="TwoFactorAuth-popup-overlay-content-error">Phone Number is not valid, please enter a valid phone number.</div>)
      ],
      footer: [
        (<div className="TwoFactorAuth-popup-overlay-footer-actions">
            <div className="TwoFactorAuth-popup-overlay-footer-actions-button-green" onClick={this.validatePhone}>Update</div>
          </div>)
      ]
    };
  }

  getDialog = () => {
    if(this.state.step < steps.Updated) {
      let content = this.getDialogContent();
      return (
        <div className="TwoFactorAuth-popup-overlay-dialog">
          <div className="TwoFactorAuth-popup-overlay-header">
              <div className="TwoFactorAuth-popup-overlay-title">{content.title}</div>
              <div className="TwoFactorAuth-popup-overlay-controlbox" onClick={() => this.props.onClose(false)}>
                  <span className="close-button">X</span>
              </div>
          </div>
          
          <div className="TwoFactorAuth-popup-overlay-content">
            {content.content}
          </div>

          <div className="TwoFactorAuth-popup-overlay-footer">
            {content.footer}
          </div>
      </div>
      );
    } else {
      if(this.state.step == steps.Verified)
        window.setTimeout(() => this.props.onClose(false, this.state.phone), 3750);
      return (
        <div className="TwoFactorAuth-popup-overlay-dialog">
            <div className="TwoFactorAuth-popup-overlay-modal">
                <div className="TwoFactorAuth-popup-overlay-modal-content">
                    Phone Number <span className="TwoFactorAuth-popup-overlay-modal-action">{this.state.step == steps.Updated ? "Updated" : "Verified"}</span>
                </div>
            </div>
        </div>
      );
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/stones/twoFactorAuthView.js